import {Component, OnInit, Input, ViewChild, EventEmitter, Output} from '@angular/core';
import {BrowseConfig} from "@core/bean/browse-config";
import {BrowseService} from "@shared/components/browse/browse.service";
import {DynamicFormService} from "../../../../routes/dev-tools/dynamic-form/dynamic-form.service";
import {CommonsService} from "@core/service/commons.service";
import {NgForm} from "@angular/forms";
import { DictService } from '../../../../routes/jy-dict/dict-info/service/dict.service';
import {Router} from "@angular/router";

@Component({
  selector: 'app-score-plan',
  templateUrl: './score-plan.component.html',
  styles: []
})
export class ScorePlanComponent implements OnInit {
  @Input() scoringScheme;
  @Input() readOnly;
  @Output() private close = new EventEmitter();

  constructor(private browseService: BrowseService, private dynamicFormService: DynamicFormService, public commonsService: CommonsService, public dictService: DictService,private router:Router) {
  };

  //评分方案列表表格
  allChecked = false;
  indeterminate = false;
  displayData = [];

  currentPageDataChange($event): void {
    this.displayData = $event;
    this.refreshStatus();
  }

  refreshStatus(): void {
    const allChecked = this.displayData.filter(value => !value.disabled).every(value => value.checked === true);
    const allUnChecked = this.displayData.filter(value => !value.disabled).every(value => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = (!allChecked) && (!allUnChecked);
  }

  checkAll(value: boolean): void {
    this.displayData.forEach(data => {
      if (!data.disabled) {
        data.checked = value;
      }
    });
    this.refreshStatus();
  }

  //编辑评分方案抽屉
  public scorePlanVisibile: boolean = false;
  //编辑或新增评分方案
  @ViewChild('scorePlanForm') scorePlanForm: NgForm;
  public planObj: any = {};
  public planIndex: any;

  editScorePlan(scorePlan?, index?) {
    if (scorePlan) {
      this.planObj = JSON.parse(JSON.stringify(scorePlan));
      this.expandFieldGroup();
      if (!this.planObj.scoringPeople) {
        this.planObj.scoringPeople = [];
      }
      if (!this.planObj.dynamicForm) {
        this.planObj.dynamicForm = {};
      }
      if (!this.planObj.dynamicForm.dynamicFields) {
        this.planObj.dynamicForm.dynamicFields = [];
      }
      this.planObj.enableViewSupAttachmentListEnt = [];
      if(this.planObj.enableViewSupAttachmentList){
        this.planObj.enableViewSupAttachmentListEnt = JSON.parse(this.planObj.enableViewSupAttachmentList);
      }
      this.planIndex = index;
    } else {
      this.planObj = {};
      this.planIndex = -1;
      this.planObj.scoringPersonType = "PERSON";
      this.planObj.scoringPeople = [];
      this.planObj.dynamicForm = {};
      this.planObj.dynamicForm.dynamicFields = [];
      this.planObj.enableViewSupAttachmentListEnt = [];
      if(this.attachTypeList){
        for(let i =0; i<this.attachTypeList.length;i++){
          this.planObj.enableViewSupAttachmentListEnt[i] = {
            label: this.attachTypeList[i].value,
            value: this.attachTypeList[i].code
          };
        }
      }
    }
    this.scorePlanVisibile = true;
  }

  //字段分组默认展开
  expandFieldGroup() {
    this.planObj.dynamicForm.dynamicTables[0].dynamicFieldGroups.forEach((data) => {
      data.expand = true;
    });
  }

  removeScorePlan() {
    let list = [];
    for (let i = 0; i < this.scoringScheme.scoringSchemeDetails.length; i++) {
      if (!this.scoringScheme.scoringSchemeDetails[i].checked) {
        list.push(this.scoringScheme.scoringSchemeDetails[i]);
      }
    }
    this.scoringScheme.scoringSchemeDetails = list;
  }

  closeScorePlanDrawer() {
    this.scorePlanVisibile = false;
  }

  //评分方案浏览按钮
  conFig: BrowseConfig = new BrowseConfig('MarkingPlanBrowseComponent');

  getMarkingPlan() {
    let flag: boolean;
    this.conFig.searchData['type'] = "SCORING";
    this.browseService.open(this.conFig,
      (result) => {
        this.planObj.describe = result.describe;
        this.dynamicFormService.getByCode(result.code).subscribe((data) => {
          if (this.scoringScheme.scoringSchemeDetails.length > 0) {
            for (let i = 0; i < this.scoringScheme.scoringSchemeDetails.length; i++) {
              if (data.code === this.scoringScheme.scoringSchemeDetails[i].dynamicForm.code) {
                flag = true;
              }
            }
          }
          if (flag) {
            this.commonsService.showInfoMessage('msg.info.existingSolution');
          } else {
            this.planObj.dynamicForm = data;
            // this.planObj.enableViewPrice = this.planObj.dynamicForm
            if(this.planObj.dynamicForm.config){
              let config = JSON.parse(this.planObj.dynamicForm.config);
              this.planObj.enableViewPrice = config.enableViewPrice ? config.enableViewPrice : false;
              // this.planObj.enableViewSupAttachment = config.enableViewSupAttachment ? config.enableViewSupAttachment : false;
              if(config.enableViewSupAttachmentList){
                for(let j=0;j<this.planObj.enableViewSupAttachmentListEnt.length;j++){
                  for (let i=0;i<config.enableViewSupAttachmentList.length;i++){
                    if(this.planObj.enableViewSupAttachmentListEnt[j].value == config.enableViewSupAttachmentList[i].value){
                      this.planObj.enableViewSupAttachmentListEnt[j].checked = (config.enableViewSupAttachmentList[i].checked ? config.enableViewSupAttachmentList[i].checked : false);
                      break;
                    }
                  }
                }
              }
            }
          }

        });
      },
      () => {
      });
  }

  //选择评分组长
  leaderConfig: BrowseConfig = new BrowseConfig('PersonBrowseComponent');

  getLeader() {
    this.leaderConfig.searchData['user.userType-eq'] = '1';
    this.browseService.open(this.leaderConfig,
      result => {
        this.planObj.leader = result;
      },
      () => {

      })
  }

  //评分人员表格
  personAllChecked = false;
  personIndeterminate = false;
  personDisplayData = [];

  personCurrentPageDataChange($event): void {
    this.personDisplayData = $event;
    this.personRefreshStatus();
  }

  personRefreshStatus(): void {
    const allChecked = this.personDisplayData.filter(value => !value.disabled).every(value => value.checked === true);
    const allUnChecked = this.personDisplayData.filter(value => !value.disabled).every(value => !value.checked);
    this.personAllChecked = allChecked;
    this.personIndeterminate = (!allChecked) && (!allUnChecked);
  }

  personCheckAll(value: boolean): void {
    this.personDisplayData.forEach(data => {
      if (!data.disabled) {
        data.checked = value;
      }
    });
    this.personRefreshStatus();
  }

  //切换评分人员类型时清空评分人员
  scoringPersonTypeChange() {
    this.planObj.scoringPeople = [];
  }

  //选择人员浏览按钮
  personConFig: BrowseConfig = new BrowseConfig('PersonBrowseComponent');

  getPerson(index) {
    this.personConFig.searchData['user.userType-eq'] = '1';
    if (index != -1) {
      this.personConFig.multiple = false;
      this.browseService.open(this.personConFig,
        (result) => {
          this.planObj.scoringPeople[index].person = result;
        },
        () => {
        });
    } else {
      this.personConFig.multiple = true;
      this.browseService.open(this.personConFig,
        (result) => {
          let list = JSON.parse(JSON.stringify(this.planObj.scoringPeople));
          result.forEach((data) => {
            let obj = {person: data};
            list.push(obj);
          });
          this.planObj.scoringPeople = list;
        },
        () => {
        });
    }

  }

  //选择专家浏览按钮
  expertConFig: BrowseConfig = new BrowseConfig('ExpertBrowseComponent');

  getExpert(index) {
    if (index != -1) {
      this.expertConFig.multiple = false;
      this.browseService.open(this.expertConFig,
        (result) => {
          this.planObj.scoringPeople[index].expertFrom = "MANUAL";
          this.planObj.scoringPeople[index].expert = result;
        },
        () => {
        });
    } else {
      this.expertConFig.multiple = true;
      this.browseService.open(this.expertConFig,
        (result) => {
          let list = JSON.parse(JSON.stringify(this.planObj.scoringPeople));
          result.forEach((data) => {
            let obj = {expertFrom: "MANUAL", expert: data};
            list.push(obj);
          });
          this.planObj.scoringPeople = list;
        },
        () => {
        });
    }

  }

  //随机抽取专家
  public randomExpertsVisibile: boolean = false;

  extractExperts() {
    this.randomExpertsVisibile = true;
  }

  cancelRandomExperts() {
    this.randomExpertsVisibile = false;
  }

  okRandomExperts(data) {
    let expertList = [];
    for (let i = 0; i < this.planObj.scoringPeople.length; i++) {
      if (this.planObj.scoringPeople[i].expertFrom == "MANUAL") {
        expertList.push(this.planObj.scoringPeople[i]);
      }
    }
    this.planObj.scoringPeople = expertList;
    for (let k = 0; k < data.length; k++) {
      let obj: any = {};
      obj.expertFrom = "RANDOM";
      obj.expert = data[k];
      this.planObj.scoringPeople.push(obj);
    }
    this.randomExpertsVisibile = false;
  }

  addMarkPerson() {
    if (this.planObj.scoringPersonType == 'PERSON') {
      this.getPerson(-1);
    } else if (this.planObj.scoringPersonType == 'EXPERT') {
      this.getExpert(-1);
    }

  }

  removeMarkPerson() {
    let personArr = [];
    for (let i = 0; i < this.planObj.scoringPeople.length; i++) {
      if (!this.planObj.scoringPeople[i].checked) {
        personArr.push(this.planObj.scoringPeople[i]);
      }
    }
    this.planObj.scoringPeople = personArr;
  }

  //选择组长
  leaderChange($event, index) {
    if ($event) {
      for (let i = 0; i < this.planObj.scoringPeople.length; i++) {
        this.planObj.scoringPeople[i].isLeader = false;
      }
      this.planObj.scoringPeople[index].isLeader = true;
    }
  }

  //保存评分方案
  saveScorePlan() {
    for (let item in this.scorePlanForm.controls) {
      this.scorePlanForm.controls[item].markAsDirty();
      this.scorePlanForm.controls[item].updateValueAndValidity();
    }
    if (!this.scorePlanForm.valid) {
      return;
    }
    let map = {};
    if (!this.planObj.scoringPeople || this.planObj.scoringPeople.length < 1) {
      this.commonsService.showWarningMessage('shared.score.score-plan.selectPeople');
      return;
    }
    if (this.planObj.scoringPersonType == 'PERSON') {
      for (let i = 0; i < this.planObj.scoringPeople.length; i++) {
        if (!map[this.planObj.scoringPeople[i].person.id]) {
          map[this.planObj.scoringPeople[i].person.id] = this.planObj.scoringPeople[i];
        } else {
          this.commonsService.showWarningMessage('shared.score.score-plan.selectDoubleP');
          return;
        }
      }
    } else if (this.planObj.scoringPersonType == 'EXPERT') {
      for (let i = 0; i < this.planObj.scoringPeople.length; i++) {
        if (!map[this.planObj.scoringPeople[i].expert.id]) {
          map[this.planObj.scoringPeople[i].expert.id] = this.planObj.scoringPeople[i];
        } else {
          this.commonsService.showWarningMessage('shared.score.score-plan.selectDoubleP');
          return;
        }
      }
    }
    if(this.planObj.enableViewSupAttachmentListEnt){
      this.planObj.enableViewSupAttachmentList = JSON.stringify(this.planObj.enableViewSupAttachmentListEnt);
    }
    if (this.planIndex != -1) {
      this.scoringScheme.scoringSchemeDetails[this.planIndex] = this.planObj;
    } else {
      this.planObj.status = "NOT_STARTED";
      let list = JSON.parse(JSON.stringify(this.scoringScheme.scoringSchemeDetails));
      list.push(this.planObj);
      this.scoringScheme.scoringSchemeDetails = list;
    }
    this.scorePlanVisibile = false;
  }

  public attachTypeList:any = [];
  ngOnInit() {
    this.dictService.getWithItemList("sourceAttachType").subscribe((data)=>{
      this.attachTypeList = data.dictItems;
      if(this.planObj && (!this.planObj.enableViewSupAttachmentListEnt || this.planObj.enableViewSupAttachmentListEnt.length == 0)){
        this.planObj.enableViewSupAttachmentListEnt = [];
        if(this.attachTypeList){
          for(let i =0; i<this.attachTypeList.length;i++){
            this.planObj.enableViewSupAttachmentListEnt[i] = {
              label: this.attachTypeList[i].value,
              value: this.attachTypeList[i].code
            };
          }
        }
      }



    })
  }

  log(value: object[]): void {
    console.log(value);
  }

//  修改评分方案
  goEditPlan(){
    this.close.emit();
    this.scorePlanVisibile = false;
    setTimeout(() => {
      this.router.navigateByUrl('/marking-scheme');
    },500);
  }

}
